export enum TransactionEventEnum {
    ON_UNBLOCK = "On Unblock",
    ON_MONTHLY_CREDIT = "On Monthly Credit",
    ON_ADMIN_CREDIT = "On Admin Credit",
    ON_HOURLY_DEBIT = "On Hourly Debit",
    ON_CONVERT_TO_CAMPAIGN = "On Convert To Campaign",
    ON_PLAN_ITEM_REMOVAL = "On Plan Item Removal",
    ON_CAMPAIGNITEM_REMOVAL = "On Campaign Item removal"
}
